/***  Bug #598  @Author Anupama P  @Date 28 Aug 2021  */
export const Usertype = [
    // {user:"/patient", type:1, login: "/login1", dashboard: "/patient/health-record"},
    {user:"/facility", type:2, login: "/", dashboard: "/facility/appointments"},
    // {user:"/facility", type:2, login: "/login", dashboard: "/facility/appointments"},
    {user:"", type:-1},
]
